
<div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="space-y-6">
         <!-- 1. Copywriter -->
         <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl">
            <h2 class="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <i class="fa-solid fa-pen-nib text-pink-500"></i> AI เขียนคอนเทนต์ (Copywriter)
            </h2>
            <p class="text-slate-400 text-sm mb-4">สร้างเนื้อหาภาษาไทย สำหรับโพสต์ลง Facebook หรือ LINE OA (พร้อม Hashtags)</p>
            
            <div class="space-y-4">
                <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">หัวข้อ / โปรโมชั่น (Topic)</label>
                    <input type="text" [(ngModel)]="marketingTopic" placeholder="เช่น ลด 50% ลูกค้าใหม่, กัญชาช่วยนอนหลับ" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2">
                </div>
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label class="block text-xs font-bold text-slate-500 mb-1">รูปแบบ (Format)</label>
                        <select [(ngModel)]="marketingFormat" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2 text-sm">
                            <option>Facebook Post</option>
                            <option>Blog Article</option>
                            <option>Email Newsletter</option>
                            <option>SMS Blast</option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-slate-500 mb-1">น้ำเสียง (Tone)</label>
                        <select [(ngModel)]="marketingTone" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2 text-sm">
                            <option>ทางการแพทย์และน่าเชื่อถือ (Medical Professional)</option>
                            <option>เป็นกันเองและอบอุ่น (Friendly & Welcoming)</option>
                            <option>ตื่นเต้นและเร่งรีบ (Exciting & Urgent)</option>
                            <option>ให้ความรู้ (Educational)</option>
                        </select>
                    </div>
                </div>
                <button (click)="generateContent()" [disabled]="isGeneratingMarketing()" class="w-full bg-pink-600 hover:bg-pink-500 text-white font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    @if(isGeneratingMarketing()){ <i class="fa-solid fa-spinner animate-spin"></i> } @else { <i class="fa-solid fa-wand-magic-sparkles"></i> }
                    สร้างคอนเทนต์ (Generate)
                </button>
            </div>
        </div>
        
        @if(generatedContent()) {
            <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl relative group">
                <button (click)="copyContent(generatedContent())" class="absolute top-4 right-4 text-slate-500 hover:text-white bg-slate-800 p-2 rounded"><i class="fa-regular fa-copy"></i></button>
                <h3 class="text-sm font-bold text-slate-400 mb-2">ผลลัพธ์ (Result):</h3>
                <div class="text-white whitespace-pre-wrap font-sans text-sm">{{ generatedContent() }}</div>
            </div>
        }

         <!-- 2. Strategy -->
         <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl">
            <h2 class="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <i class="fa-solid fa-chess text-blue-500"></i> ผู้ช่วยวางแผนกลยุทธ์ (AI Strategy)
            </h2>
            <p class="text-slate-400 text-sm mb-4">ให้ AI ช่วยคิดแผนการตลาดสำหรับเดือนถัดไป</p>
            
            <div class="space-y-4">
                 <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">เป้าหมาย (Goal)</label>
                    <input type="text" [(ngModel)]="strategyGoal" placeholder="เช่น เพิ่มยอดคนไข้ใหม่ 20%" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">กลุ่มเป้าหมาย (Target Audience)</label>
                    <input type="text" [(ngModel)]="strategyAudience" placeholder="เช่น พนักงานออฟฟิศที่มีอาการนอนไม่หลับ" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2">
                </div>
                 <button (click)="generateStrategy()" [disabled]="isGeneratingMarketing()" class="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    @if(isGeneratingMarketing()){ <i class="fa-solid fa-spinner animate-spin"></i> } @else { <i class="fa-solid fa-lightbulb"></i> }
                    ขอไอเดียกลยุทธ์ (Plan Strategy)
                </button>
            </div>
        </div>
        
        @if(generatedStrategy()) {
            <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl relative group">
                <button (click)="copyContent(generatedStrategy())" class="absolute top-4 right-4 text-slate-500 hover:text-white bg-slate-800 p-2 rounded"><i class="fa-regular fa-copy"></i></button>
                <h3 class="text-sm font-bold text-slate-400 mb-2">แผนกลยุทธ์ (Strategy Plan):</h3>
                <div class="text-white whitespace-pre-wrap font-sans text-sm">{{ generatedStrategy() }}</div>
            </div>
        }
    </div>

    <div class="space-y-6">
         <!-- 3. Video Script -->
         <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl border-l-4 border-l-red-500">
            <h2 class="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <i class="fa-brands fa-tiktok text-red-500"></i> เขียนบทวิดีโอสั้น (AI Video Script)
            </h2>
            <p class="text-slate-400 text-sm mb-4">สร้างสคริปต์สำหรับ TikTok/Reels แบบมืออาชีพ</p>
            
            <div class="space-y-4">
                 <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">หัวข้อคลิป (Topic)</label>
                    <input type="text" [(ngModel)]="videoTopic" placeholder="เช่น 3 วิธีใช้น้ำมันกัญชา, รีวิวคลินิก" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">ความยาว (Duration)</label>
                    <select [(ngModel)]="videoDuration" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2 text-sm">
                        <option>Short (15-30s) - TikTok</option>
                        <option>Medium (60s) - Reels</option>
                        <option>Long (3 min) - Education</option>
                    </select>
                </div>
                 <button (click)="generateVideoScript()" [disabled]="isGeneratingMarketing()" class="w-full bg-red-600 hover:bg-red-500 text-white font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    @if(isGeneratingMarketing()){ <i class="fa-solid fa-spinner animate-spin"></i> } @else { <i class="fa-solid fa-clapperboard"></i> }
                    เขียนสคริปต์ (Write Script)
                </button>
            </div>
        </div>
        
        @if(generatedScript()) {
            <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl relative group">
                <button (click)="copyContent(generatedScript())" class="absolute top-4 right-4 text-slate-500 hover:text-white bg-slate-800 p-2 rounded"><i class="fa-regular fa-copy"></i></button>
                <h3 class="text-sm font-bold text-slate-400 mb-2">บทวิดีโอ (Script):</h3>
                <div class="text-white whitespace-pre-wrap font-sans text-sm border-l-2 border-slate-700 pl-3">{{ generatedScript() }}</div>
            </div>
        }

         <!-- 4. Image Gen -->
         <div class="bg-slate-900 border border-slate-800 p-6 rounded-xl">
            <h2 class="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <i class="fa-solid fa-image text-indigo-500"></i> สร้างรูปภาพ (AI Image Studio)
            </h2>
            <p class="text-slate-400 text-sm mb-4">สร้างภาพประกอบสวยๆ สำหรับใช้ในคลินิกหรือสื่อโฆษณา</p>
            
            <div class="space-y-4">
                 <div>
                    <label class="block text-xs font-bold text-slate-500 mb-1">คำบรรยายภาพ (Prompt)</label>
                    <textarea [(ngModel)]="marketingImagePrompt" rows="3" placeholder="e.g. A modern clean medical cannabis clinic interior with soft lighting, 4k (แนะนำให้พิมพ์เป็นภาษาอังกฤษ)" class="w-full bg-slate-950 border border-slate-700 text-white rounded p-2"></textarea>
                </div>
                 <button (click)="generateImage()" [disabled]="isGeneratingMarketing()" class="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    @if(isGeneratingMarketing()){ <i class="fa-solid fa-spinner animate-spin"></i> } @else { <i class="fa-solid fa-paint-brush"></i> }
                    สร้างรูปภาพ (Generate Image)
                </button>
            </div>
        </div>

        @if(generatedImageUrl()) {
            <div class="bg-slate-900 border border-slate-800 p-4 rounded-xl">
                <img [src]="generatedImageUrl()" class="w-full rounded-lg shadow-lg">
                <div class="mt-2 text-center">
                    <a [href]="generatedImageUrl()" download="marketing.jpg" target="_blank" class="text-indigo-400 hover:text-white text-sm underline">ดาวน์โหลดรูปภาพ (Download)</a>
                </div>
            </div>
        }
    </div>
</div>
